import JSONAPISerializer from '@ember-data/serializer/json-api';
import { singularize } from '@warp-drive/utilities/string';

// these methods are overwritten so updated_by doesn't get converted to updated-by and zip_code doesn't get converted to zip-code
export default class ApplicationSerializer extends JSONAPISerializer {
  keyForAttribute(key) {
    return key;
  }
  serialize(/*snapshot, options*/) {
    let json = super.serialize(...arguments);
    json.data.type = singularize(json.data.type);

    return json;
  }
  // payloadKeyFromModelName(modelName) {
  //   const su = super.payloadKeyFromModelName(modelName);
  //   console.log(modelName, su);
  //   return su;
  // }
  keyForRelationship(key, typeClass, method) {
    // const su = super.keyForRelationship(key, typeClass, method);
    // console.log(key, typeClass, method, su);
    return key;
  }
}
